enum GlobalSearchItemType {
  ENTITY,
  QUERY,
  LOCAL_QUERY,
  LEAD_FINDER,
}

export default GlobalSearchItemType;
